import React from "react";
import { modalService } from "services";
import { Button, Card } from "reactstrap";
import { FA } from "components/FA";
import styles from "./Terms.module.css";

const TermsContent = ({ isModal, close }) => (
  <>
    <h3 className="card-header">
      General Terms of Service{" "}
      {isModal && (
        <FA title="Close" onClick={() => close()} icon="times" size="xs" />
      )}
    </h3>
    <div className="card-body">TERMS {isModal ? " (Modal)" : ""}</div>
  </>
);

const Terms = ({ history }) => (
  <>
    {history.length > 2 && (
      <Button color="link" onClick={history.goBack}>
        <FA icon="angle-left" size="xs" /> back
      </Button>
    )}
    <Card className={styles.card}>
      <TermsContent />
    </Card>
  </>
);

const openTermsModal = () =>
  modalService.open({
    id: "terms",
    children: (
      <TermsContent isModal={true} close={() => modalService.close("terms")} />
    ),
  });

export { Terms, openTermsModal };
